import { useEffect, useState } from "react";
import { api, label } from "../lib/api";
import { PageHeader, Select, Spinner } from "../components/bits";
import { Timeline } from "./group/Tabs";

export default function Activity() {
  const [groups, setGroups] = useState([]);
  const [logs, setLogs] = useState(null);
  const [f, setF] = useState({ group_id: "", category: "" });
  useEffect(() => { api.get("/groups").then((r) => setGroups(r.data)); }, []);
  useEffect(() => { api.get("/activity", { params: Object.fromEntries(Object.entries(f).filter(([, v]) => v)) }).then((r) => setLogs(r.data)); }, [f]);
  return (
    <div data-testid="activity-page">
      <PageHeader title="Activity" subtitle="Everything that happens across your groups, in order." action={<Select testId="activity-group-filter" value={f.group_id} onChange={(v) => setF({ ...f, group_id: v })} placeholder="All groups" options={groups.map((g) => [g.id, g.name])} className="!w-52" />} />
      <div className="flex flex-wrap gap-2 mb-6">{["", "financial", "membership", "settings", "approvals", "system"].map((c) => <button key={c} onClick={() => setF({ ...f, category: c })} className={`tab-btn ${f.category === c ? "tab-btn-active" : ""}`} data-testid={`activity-filter-${c || "all"}`}>{c ? label(c) : "All"}</button>)}</div>
      {!logs ? <Spinner /> : <Timeline logs={logs} showGroup />}
    </div>
  );
}
